import { render, staticRenderFns } from "./lu-upload-file.vue?vue&type=template&id=7870d06f&"
import script from "./lu-upload-file.vue?vue&type=script&lang=js&"
export * from "./lu-upload-file.vue?vue&type=script&lang=js&"
import style0 from "./lu-upload-file.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.7.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports